// components
import Modal from '@drivesally/sally-ui/lib/components/Modal/Modal';
import TableRow from '@drivesally/sally-ui/lib/components/Table/components/Row.Table';


// layout components
import AttributeInput from '../../../components/components/atoms/AttributeInput/AttributeInput';
import CompactDataRow from '../../../layout/components/CompactDataRow/CompactDataRow';
import TextArea from '../../../layout/components/TextArea/TextArea';
import styled from 'styled-components';


// propTypes
import PropTypes from 'prop-types';

// react
import React from 'react';

// libs
import displayTimeZoneSpecificDate from '../../../libs/displayTimeZoneSpecificDate';

// types
import {dateTime} from '@drivesally/sally-fw/lib/type';



const TextContainer = styled.div`
  width: 100%;
  padding-left: 0px;
  padding-top: 10px;
`;


const RepoDetailsModal = ({
  visible,
  onClose,
  onSave,
  onChange,
  saving,
  repo,
  repo_type,
  repo_outcome,
  repo_reason,
  repo_notes,
  deactivation_notes,
  rent_after_balance_is_paid,
}) => {
  const dataRowProps = {
    labelSpan: 2,
    contentSpan: 2,
  };
  const inputRowProps = {
    ...dataRowProps,
    wrapContent: true,
    noPadding: true,
  };

  return (
    <Modal
      visible={visible}
      title="Deactivation"
      onClose={onClose}
      buttonsRight={[{label: 'Save', loading: saving, onClick: onSave}]}
    >
      {(Content) =>
        !repo ? (
          <Content />
        ) : (
          
          <Content padding="none" noBorder>
            <TableRow portions={4} noHover>
              {(TableColumn) => [
                <TableColumn
                  key="separator"
                  span={4}
                  border="solid solid solid solid"
                >
                  <b>Deactivation Details</b>
                </TableColumn>,
              ]}
            </TableRow>
            <CompactDataRow label="Rental ID" {...dataRowProps}>
              {repo?.rental?.id || '-'}
            </CompactDataRow>
            <CompactDataRow label="Deactivation ID" {...dataRowProps}>
              {repo?.id || '-'}
            </CompactDataRow>
            <CompactDataRow label="Initiated By" {...dataRowProps}>
              {repo?.repo_initiated_by_username || '-'}
            </CompactDataRow>

            <CompactDataRow label="Deactivation Days" {...dataRowProps}>
              {repo?.deactivation_days || '-'}
            </CompactDataRow>

            <CompactDataRow label="Deactivation Date" {...dataRowProps}>
              {displayTimeZoneSpecificDate({
                date: repo?.repo_start_date,
                type: dateTime,
                branch: repo?.sally_branch,
              })}
            </CompactDataRow>
            <CompactDataRow label="Prior Deactivations" {...dataRowProps}>
              {repo?.driver?.repo_counts || '-'}
            </CompactDataRow>
            <CompactDataRow label="Days Since Last Payment" {...dataRowProps}>
              {repo?.driver?.days_since_last_payment || '-'}
            </CompactDataRow>
            <CompactDataRow
              label={repo_reason.label.default}
              {...inputRowProps}
            >
              <AttributeInput
                value={repo_reason}
                onChange={onChange}
                disabled={saving}
                size="small"
                flat
                notFilterable
              />
            </CompactDataRow>
            <CompactDataRow
              label={repo_outcome.label.default}
              {...inputRowProps}
            >
              <AttributeInput
                value={repo_outcome}
                onChange={onChange}
                disabled={saving}
                size="small"
                flat
                notFilterable
              />
            </CompactDataRow>
            <CompactDataRow
              label={rent_after_balance_is_paid.label.default}
              {...inputRowProps}
            >
              <AttributeInput
                value={rent_after_balance_is_paid}
                onChange={onChange}
                disabled={saving}
                size="small"
                flat
                notFilterable
              />
            </CompactDataRow>

            <TableRow portions={4} noHover>
              {(TableColumn) => [
                <TableColumn
                  key="separator"
                  span={4}
                  border="solid solid solid solid"
                >
                  <b>{deactivation_notes.label.default}</b>
                  <TextContainer>
                    <TextArea
                    value={deactivation_notes?.value() || ''}
                    onChange={(value) => onChange(deactivation_notes?.reinit(value), 'deactivation_notes')}
                    disabled={saving}
                    placeholder="Enter deactivation notes..."
                  />
                </TextContainer>
                </TableColumn>,
              ]}
            </TableRow>
            
            
            <TableRow portions={4} noHover>
              {(TableColumn) => [
                <TableColumn
                  key="separator"
                  span={4}
                  border="solid solid solid solid"
                >
                  <b>Repossession Details</b>
                </TableColumn>,
              ]}
            </TableRow>

            <CompactDataRow label={repo_type.label.default} {...inputRowProps}>
              <AttributeInput
                value={repo_type}
                onChange={onChange}
                disabled={saving}
                size="small"
                flat
                notFilterable
              />
            </CompactDataRow>
            <CompactDataRow label="Rental Return Date" {...dataRowProps}>
              {displayTimeZoneSpecificDate({
                date: repo?.rental?.end_date,
                type: dateTime,
                branch: repo?.sally_branch,
              })}
            </CompactDataRow>
            
            <CompactDataRow label="Repo Duration" {...dataRowProps}>
              {repo?.repo_duration || '-'}
            </CompactDataRow>

            <CompactDataRow label="Driver State" {...dataRowProps}>
              {repo?.driver?.state || '-'}
            </CompactDataRow>


            <TableRow portions={4} noHover>
              {(TableColumn) => [
                <TableColumn
                  key="separator"
                  span={4}
                  border="solid solid solid solid"
                >
                  <b>{repo_notes.label.default}</b>
                  <TextContainer>
                    <TextArea
                    value={repo_notes?.value() || ''}
                    onChange={(value) => onChange(repo_notes?.reinit(value), 'repo_notes')}
                    disabled={saving}
                    placeholder="Enter repo notes..."
                  />
                </TextContainer>
                </TableColumn>,
              ]}
            </TableRow>

          
          </Content>
        )
      }
    </Modal>
  );
};

RepoDetailsModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  repo: PropTypes.object,
  repo_type: PropTypes.object,
  repo_outcome: PropTypes.object,
  repo_reason: PropTypes.object,
  repo_notes: PropTypes.object,
  deactivation_notes: PropTypes.object,
  rent_after_balance_is_paid: PropTypes.object,
  saving: PropTypes.bool,
};

export default RepoDetailsModal;
